import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getCountry } from "../../features/country";
import { prepareSelectData } from "../../utils/commonHelper";
import SelectDropdown from "../SelectDropdown";
import { Form } from "react-bootstrap";
import { useFormikContext } from "formik";
import { useTranslation } from "react-i18next";

const UpdatedMobileNumberInput = ({
  name = "mobile",
  codeName = "country_code",
  defaultCode = "+968",
}) => {
  const dispatch = useDispatch();
  const { setFieldValue, values } = useFormikContext();
  const { t, i18n } = useTranslation();
  const currentLanguage = i18n.language;
  const [countryCode, setCountryCode] = useState(
    values[codeName] || defaultCode
  );
  const [mobileNumber, setMobileNumber] = useState(values[name] || "");

  const { data: countries } = useSelector((state) => state.country);

  useEffect(() => {
    if (!(countries && countries.length)) {
      dispatch(getCountry());
    }
  }, [countries, dispatch]);

  const handleCountryChange = (field, value) => {
    setCountryCode(value);
    setFieldValue(codeName, value);
  };

  const handleNumberChange = (e) => {
    const value = e.target.value;
    setMobileNumber(value);
    setFieldValue(name, value);
  };

  return (
    <div className="input-group country_mbl_number">
      <SelectDropdown
        name={codeName}
        placeholder={defaultCode}
        options={prepareSelectData(countries, "country_code", "en")}
        handleOnChange={handleCountryChange}
        isSearchable={true}
        defaultValue={{ label: countryCode, value: countryCode }}
      />

      <Form.Control
        type="tel"
        className="element-style"
        placeholder={t("mobile_no")}
        pattern="[0-9]{6,15}"
        value={mobileNumber}
        onChange={handleNumberChange}
        lang="en"
        style={{
          unicodeBidi: "plaintext",
          direction: "ltr",
        }}
      />
    </div>
  );
};

export default UpdatedMobileNumberInput;
